import { render, staticRenderFns } from "./presSumas.vue?vue&type=template&id=5896fe45"
import script from "./presSumas.vue?vue&type=script&lang=js"
export * from "./presSumas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports